import React, { useState, useRef, useEffect } from "react";
import {  DefaultImageBaseurl, endPoints } from "../constant/Environment";
import { addData, getAllData } from "../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Toaster from "../components/Toast";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import { ErrorToast, SuccesToast } from "../components/Toast/message";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import {
  TableFooter,
  TablePagination,
  Switch,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
  IconButton,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  TableSortLabel,
  Box,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import ViewModal from "./ViewModal";
import SuccesModal from "./SuccesModal";
import CancelModal from "./CancelModal";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const OfferPost = () => {
  const [selectedData, setSelectedData] = useState({});
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [searchText, setSearchText] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const [checkboxes, setCheckboxes] = useState({
    isCheckedActive: false,
  });

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchConfiguration();
  }, []);

  const fetchConfiguration = async () => {
    let url = `${endPoints.api.GET_SOCIAL_POST}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  const statusLabel = (s) =>
    s == 0 ? "Pending" : s == 1 ? "Approved" : s == 2 ? "cancel" : "Pending";

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
    setPage(0);
  };

  const rowsToDisplay = React.useMemo(() => {
    let result = rows;

    if (searchText) {
      const q = searchText.toLowerCase();
      result = result.filter(
        (row) =>
          String(row.id_user || "").includes(q) ||
          String(row.name || "").toLowerCase().includes(q) ||
          String(row.email || "").toLowerCase().includes(q) ||
          String(row.offerName || "").toLowerCase().includes(q) ||
          statusLabel(row.status).toLowerCase().includes(q)
      );
    }

    if (sortConfig.key) {
      result = [...result].sort((a, b) => {
        let av = sortConfig.key === "status" ? statusLabel(a.status) : a[sortConfig.key];
        let bv = sortConfig.key === "status" ? statusLabel(b.status) : b[sortConfig.key];
        av = av ?? "";
        bv = bv ?? "";
        let cmp;
        if (!isNaN(Number(av)) && !isNaN(Number(bv)) && av !== "" && bv !== "") {
          cmp = Number(av) - Number(bv);
        } else {
          cmp = String(av).localeCompare(String(bv), undefined, { sensitivity: "base" });
        }
        return sortConfig.direction === "asc" ? cmp : -cmp;
      });
    }

    return result;
  }, [rows, searchText, sortConfig]);

  const sortableHeader = (key, label) => (
    <TableCell align="center" sortDirection={sortConfig.key === key ? sortConfig.direction : false}>
      <TableSortLabel
        active={sortConfig.key === key}
        direction={sortConfig.key === key ? sortConfig.direction : "asc"}
        onClick={() => handleSort(key)}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Offer List" crumb="Promotions / Offer List" />

              <div style={{ marginTop: "10px" }}>
                <div className="row" style={{ marginBottom: "14px" }}>
                  <div className="col-md-5">
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Search by user ID, name, email, offer or status"
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        setPage(0);
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            {sortableHeader("id_user", "User Id")}
                            {sortableHeader("name", "Name")}
                            {sortableHeader("email", "Email")}
                            {sortableHeader("offerName", "Offer Name")}
                            {sortableHeader("goldCoin", "Gold Coins")}
                            <TableCell align="center">User Image</TableCell>
                            {sortableHeader("status", "Status")}
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">
                                  {row.id_user}
                                </TableCell>
                                <TableCell align="center">{row.name}</TableCell>
                                <TableCell align="center">
                                  {row.email}
                                </TableCell>
                                <TableCell align="center">{`${row?.offerName}`}</TableCell>
                                <TableCell align="center">
                                  {row.goldCoin}
                                </TableCell>

                                <TableCell align="center">
                                  <img
                                    src={`${DefaultImageBaseurl}${row.post_image}`}
                                    style={{ height: "50px" }}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  {row.status == 0
                                    ? "Pending"
                                    : row.status == 1
                                    ? "Approved"
                                    : row.status == 2
                                    ? "cancel"
                                    : "Pending"}
                                </TableCell>

                                <TableCell align="center">
                                  <div>
                                    <ViewModal
                                      setSelectedData={() => {
                                        setSelectedData(row);
                                      }}
                                      selectedData={selectedData}
                                    />
                                    {row.status == 0 && (
                                      <SuccesModal
                                        setSelectedData={() => {
                                          setSelectedData(row);
                                        }}
                                        selectedData={selectedData}
                                      />
                                    )}
                                    {row.status == 0 && (
                                      <CancelModal
                                        setSelectedData={() => {
                                          setSelectedData(row);
                                        }}
                                        selectedData={selectedData}
                                      />
                                    )}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferPost;
